import { ADD_RESULT, RESET_RESULTS, UNDO_LAST_RESULTS, PREDICT } from '../actions'
import dotProp from 'dot-prop-immutable';
import _ from 'lodash';
import makeTable from '../../libs/baccaratTable'

const initialState = {
    nextGame: 0,
    results: [],
    winloss: [],
    money: [0],
    predict: ['X'], //Banker, Player, Wait, Xnotsure

    table: (new Array(5).fill('      ')).map(c => c.split('')),
}

export default (state, action) => {
    let state_ = state || initialState;
    switch (action.type) {
        case ADD_RESULT:
            action.data.forEach(c => {
                state_ = dotProp.set(state_, `results`, [...state_.results, c]);
                state_ = dotProp.set(state_, `winloss`, [...state_.winloss, winloss(state_, state_.nextGame)]);
                state_ = dotProp.set(state_, `predict`, [...state_.predict, 'W']);
                state_ = dotProp.set(state_, `money`, [...state_.money, 0]);
                state_ = dotProp.set(state_, `nextGame`, state_.nextGame + 1);
                state_ = dotProp.set(state_, `table`, makeTable(state_.results));
            });
            return state_;

        case RESET_RESULTS:
            state_ = dotProp.set(state_, `results`, []);
            state_ = dotProp.set(state_, `winloss`, []);
            state_ = dotProp.set(state_, `money`, [0]);
            state_ = dotProp.set(state_, `predict`, ['X']);
            state_ = dotProp.set(state_, `nextGame`, 0);
            state_ = dotProp.set(state_, `table`, makeTable(state_.results));
            return state_;

        case UNDO_LAST_RESULTS:
            if (state_.nextGame > 0) {
                state_ = dotProp.set(state_, `results`, state_.results.filter((_, i) => i !== (state_.results.length - 1)));
                state_ = dotProp.set(state_, `winloss`, state_.winloss.filter((_, i) => i !== (state_.winloss.length - 1)));
                state_ = dotProp.set(state_, `predict`, state_.predict.filter((_, i) => i !== (state_.predict.length - 1)));
                state_ = dotProp.set(state_, `money`, state_.money.filter((_, i) => i !== (state_.money.length - 1)));
                state_ = dotProp.set(state_, `nextGame`, state_.nextGame - 1);
                state_ = dotProp.set(state_, `table`, makeTable(state_.results));
            }
            return state_;
        case PREDICT:
            if (action.data.nextGame === state_.nextGame) {
                state_ =  dotProp.set(state_, `predict.${action.data.nextGame}`, action.data.predict);
                state_ = dotProp.set(state_, `money.${action.data.nextGame}`, action.data.money);
            } else {
                console.log('Too late')
            }

            return state_;
    
    }
    return state || initialState
}

const winloss = (state, index) => {
    const result = state.results[index];
    const predict = state.predict[index];
    const money = state.money[index];

    if (predict === 'W' || predict === 'X') {
        return 0;
    }

    if (result === predict) {
        if (result === 'T') {
            return money * 8;
        }
        return money;
    }

    if (result === 'T') {
        return 0;
    }

    return -money;
}
